// extracted by mini-css-extract-plugin
module.exports = {"salesforceLabel":"style_salesforceLabel__3YKnD"};